import {
  formatDateFromDB,
  formatDateTime,
} from '../../../../../utils/FormatDate';

const formatFileSize = (size) => {
  const num = Number(size);
  if (!Number.isFinite(num) || num <= 0) return '';
  return `${(num / 1024 ** 2).toFixed(2)} MB`;
};

export const mapDokumentiToUpdates = (docs) => {
  if (!Array.isArray(docs)) return [];

  return docs.map((doc) => {
    const isImage = !!doc.type?.startsWith('image');
    const isVideo = !!doc.type?.startsWith('video');

    return {
      id: doc.id,
      datum: doc.vremeKreiranja ? formatDateFromDB(doc.vremeKreiranja) : '—',
      vreme: doc.vremeKreiranja ? formatDateTime(doc.vremeKreiranja) : '',
      kategorija: doc.nazivVrsteDokumenta || '',
      naslov: doc.parentNaziv || doc.name || '',
      opis: doc.opis || doc.name || '',
      path: doc.path || null,
      type: doc.type || '',
      name: doc.name || '',
      size: doc.size,
      isImage,
      isVideo,
      hasVideo: isVideo,
      thumbnailUrl: isImage ? doc.path : null,
      fajl: {
        naziv: doc.name || '',
        velicina: formatFileSize(doc.size),
        path: doc.path || null,
      },
    };
  });
};
